export default {
  highcharts: 'Chart',
  highstock: 'StockChart',
  highmaps: 'Map',
  'highcharts-renderer': 'Renderer'
};



//////////////////
// WEBPACK FOOTER
// ./~/vue-highcharts/src/constructors.js
// module id = 113
// module chunks = 3